import React, {createContext, useContext} from 'react';
import {useParams} from 'react-router-dom';

import {useTeamPageProjectsQuery} from '../../generated/graphql';

export type TeamPageContextType = {
  teamProjectData: {
    data: any; // TODO: fix this type, the nested maybe type is impossible
    loading: boolean;
  };
};
export const TeamPageContext = createContext<TeamPageContextType | undefined>(
  undefined
);

type TeamPageContextProviderProps = {
  children: React.ReactNode;
};
export const TeamPageContextProvider = ({
  children,
}: TeamPageContextProviderProps) => {
  const {entityName} = useParams<{entityName: string}>();

  const teamPageProjectsQuery = useTeamPageProjectsQuery({
    variables: {entityName},
  });

  return (
    <TeamPageContext.Provider
      value={{
        teamProjectData: {
          data: teamPageProjectsQuery.data?.entity?.projects,
          loading: teamPageProjectsQuery.loading,
        },
      }}>
      {children}
    </TeamPageContext.Provider>
  );
};

export const useTeamPageContext = () => {
  const value = useContext(TeamPageContext);

  if (value === undefined) {
    throw new Error(
      'useTeamPageContext must be used within a TeamPageContextProvider'
    );
  }

  return {
    teamProjectData: value.teamProjectData,
  };
};
